import React from 'react'
import { Modal, Grid, Typography, Button } from '@mui/material'
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline'
import { useStyles } from '../style.js'
import { useNavigate } from 'react-router-dom'
import { routes } from '../../../router/routes.js'

export const SuccessModal = ({ open, tenantName, handleClose }) => {
  const classes = useStyles()
  const navigate = useNavigate()

  const close = () => {
    handleClose()
    navigate(routes.login.path)
  }

  return (
    <Modal
      open={open}
      onClose={close}
      data-test='success-modal'
      aria-labelledby='success-modal-title'
      aria-describedby='success-modal-description'
      style={{ backdropFilter: 'blur(5px)' }}
    >
      <Grid
        container
        className={classes.modal}
        justifyContent='center'
        alignItems='center'
        flexDirection='column'
      >
        <Grid item>
          <CheckCircleOutlineIcon
            className={classes.successIcon}
          />
        </Grid>
        <Grid item>
          <Typography className={classes.title}>
            You have signed up successfully
          </Typography>
          <Typography className={classes.description}>
            Welcome to <strong>{tenantName}</strong>
          </Typography>

          <Typography className={classes.description}>
            Please check your email for activation.
          </Typography>
        </Grid>
        <Grid item>
          <Button variant='contained' color='primary' onClick={close}>
            Ok got it
          </Button>
        </Grid>
      </Grid>
    </Modal>
  )
}
